<script>
import { mapActions, mapState } from 'vuex';
import ItineraryIncludeList from './ItineraryIncludeList';

export default {
  name: 'ItineraryIncludeWrapper',
  components: {
    ItineraryIncludeList,
  },
  props: {
    includeNot: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      itineraryId: null,
    };
  },
  computed: {
    ...mapState({
      loading: state => state.itinerary.includes.loading,
      items: state => state.itinerary.includes.items,
      selectedDomain: state => state.itinerary.domains.selected,
      includeCategories: state => state.itinerary.includeCategories.items,
    }),
  },
  methods: {
    ...mapActions({
      getIncludeEntries: 'itinerary/getIncludeEntries',
      updateItineraryDomains: 'itinerary/updateItineraryDomains',
      getIncludeCategories: 'itinerary/getIncludeCategories',
      updateIncludeEntries: 'itinerary/updateIncludeEntries',
    }),
    saveIncludes(data) {
      const payload = {
        itineraryId: this.itineraryId,
        includeNot: this.includeNot,
        data,
      };
      this.updateIncludeEntries(payload);
    },
    updateItineraryDomain(event) {
      this.updateItineraryDomains({
        itineraryId: this.$route.params.id,
        itineraryDomains: [event],
      });
    },
  },
  created() {
    this.itineraryId = +this.$route.params.id;
    this.getIncludeEntries({ itineraryId: this.itineraryId, includeNot: this.includeNot });
    this.getIncludeCategories(this.itineraryId);
  },
};
</script>

<template>
  <div>
    <itinerary-include-list
      :itinerary-id="itineraryId"
      :loading="loading"
      :include-items="items"
      :selected-domain="selectedDomain"
      :include-categories="includeCategories"
      :list-title="title"
      @saveIncludes="saveIncludes"
      @updateDomain="updateItineraryDomain"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryIncludeWrapper.vue